import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MobileLayout from '../../components/mobile/MobileLayout';
import { useWebsiteImages, slotBackground, useGiving, BANK_ROWS } from '../../lib/publicContent';
import { ed, usePageMeta } from '../../lib/editTexts';

// Bankdaten und PayPal kommen aus AgoraHub (Inhalte → Geben) und sind dort zentral gepflegt (data-edit-central).
export default function MobileGiving() {
  const { t, i18n } = useTranslation();
  const slots = useWebsiteImages();
  const giving = useGiving(i18n.language);
  usePageMeta('giving');
  const [copied, setCopied] = useState('');

  const copy = (text, key) => {
    try { navigator.clipboard?.writeText(text); } catch {}
    setCopied(key);
    setTimeout(() => setCopied(''), 2200);
  };
  // Vor der Antwort Platzhalter (kein Springen), danach nur Zeilen mit Wert.
  const rows = giving.ready ? BANK_ROWS.filter(row => giving.bank[row.field]) : BANK_ROWS;

  return (
    <MobileLayout>
      <section className="m-hero">
        <span className="m-kicker" {...ed('giving.eyebrow')}>{t('giving.eyebrow')}</span>
        <h1 {...ed('giving.title')}>{t('giving.title')}</h1>
        <p {...ed('giving.description')}>{t('giving.description')}</p>
      </section>

      <div className="m-photo" data-slot="page.giving" style={{ height: 200, ...slotBackground(slots, 'page.giving', 0, '/kac-assets/photos/DSC09748.jpg', 'center 38%') }} />

      <section className="m-sec">
        <div className="m-head">
          <span className="m-kicker" {...ed('giving.methods_kicker')}>{t('giving.methods_kicker')}</span>
          <h2 {...ed('giving.methods_title')}>{t('giving.methods_title')}</h2>
        </div>

        {/* PayPal */}
        <div className="m-red m-red-radius" style={{ padding: '28px 24px' }}>
          <div {...ed('giving.paypal.kicker')} style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', color: 'rgba(255,255,255,0.78)', marginBottom: 14 }}>{t('giving.paypal.kicker')}</div>
          <h3 {...ed('giving.paypal.title')} style={{ margin: '0 0 12px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 26, letterSpacing: '-0.01em' }}>
            {t('giving.paypal.title')}
          </h3>
          <p {...ed('giving.paypal.description')} style={{ margin: '0 0 24px', fontSize: 15, lineHeight: 1.55, color: 'rgba(255,255,255,0.9)' }}>
            {t('giving.paypal.description')}
          </p>
          <a
            href={giving.paypalUrl || undefined}
            aria-disabled={giving.paypalUrl ? undefined : 'true'}
            data-edit-central="giving"
            target="_blank" rel="noopener noreferrer"
            className="m-btn m-btn-white"
            style={giving.paypalUrl ? undefined : { opacity: 0.6 }}
          >
            <span {...ed('giving.paypal.button')}>{t('giving.paypal.button')}</span> →
          </a>
        </div>

        {/* Bank */}
        <div className="m-card" style={{ marginTop: 18, padding: '28px 24px' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 6, gap: 10 }}>
            <div {...ed('giving.bank.kicker')} style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', color: '#C0291F' }}>{t('giving.bank.kicker')}</div>
            <div {...ed('giving.bank.copy_hint')} style={{ fontSize: 11, color: '#9b8f7f' }}>{t('giving.bank.copy_hint')}</div>
          </div>
          <h3 {...ed('giving.bank.title')} style={{ margin: '0 0 18px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 26, letterSpacing: '-0.01em' }}>
            {t('giving.bank.title')}
          </h3>

          {rows.map((row, i) => {
            const value = giving.bank[row.field] || '';
            return (
              <button
                key={row.key}
                type="button"
                disabled={!value}
                onClick={() => copy(value, row.key)}
                style={{
                  display: 'block', width: '100%', textAlign: 'left', padding: '13px 0',
                  background: 'none', border: 'none',
                  borderBottom: i < rows.length - 1 ? '1px solid rgba(120,100,70,0.2)' : 'none',
                  cursor: value ? 'pointer' : 'default', fontFamily: 'inherit', color: 'inherit',
                }}
              >
                <div {...ed(`giving.bank.${row.key}`)} style={{ fontSize: 13, color: '#857A6E', marginBottom: 4 }}>{t(`giving.bank.${row.key}`)}</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                  <span data-edit-central="giving" style={{ fontWeight: 700, fontSize: 15, color: '#26211C', fontVariantNumeric: 'tabular-nums' }}>{value || '…'}</span>
                  <span {...ed(copied === row.key ? 'giving.bank.copied' : 'giving.bank.copy')} style={{
                    fontSize: 11, fontWeight: 600, flexShrink: 0,
                    color: copied === row.key ? '#1F8A5B' : '#B6AA98',
                    transition: 'color .2s ease',
                  }}>
                    {copied === row.key ? t('giving.bank.copied') : t('giving.bank.copy')}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </section>
    </MobileLayout>
  );
}
